import { useState } from "react";

import Note from "./Note";
import NoteAdd from "./NoteAdd";
import NoteDelete from "./NoteDelete";

import {
  addNoteToConversation,
  deleteNoteFromConversation,
} from "V2.0/services/conversationService";
import { getCurrentUser } from "V2.0/services/authService";

function Notes(props) {
  const { notes, users, conversationId, workspaceId, syncConversation, isViewOnly } = props;
  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    note: null,
  });

  const activeUser = getCurrentUser();

  const handleAddNote = async (note, lifecycleCbs) => {
    const { onInit, onSuccess, onError } = lifecycleCbs;

    onInit();

    const payload = { note };

    try {
      const response = await addNoteToConversation({
        workspaceId,
        conversationId,
        payload,
      });
      if (response.status === 200) {
        onSuccess();
        console.log({ data: response.data });
        syncConversation(response.data);
      }
    } catch (e) {
      onError(e);
    }
  };

  const handleDeleteNote = async (lifecycleCbs) => {
    const { onInit, onSuccess, onError } = lifecycleCbs;

    onInit();

    try {
      const response = await deleteNoteFromConversation({
        workspaceId,
        conversationId,
        noteId: openDelete.note._id,
      });
      if (response.status === 200) {
        onSuccess();
        syncConversation(response.data);
      }
    } catch (e) {
      onError(e);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-y-4 p-6">
        {!isViewOnly && (
          <div className="flex justify-end">
            <NoteAdd onNoteAdd={handleAddNote} />
          </div>
        )}
        <div className="flex flex-col gap-y-8">
          {notes?.map((note, idx) => {
            const { user: userId } = note;
            const user = users[userId];

            const isUserActiveUser = userId === activeUser.userId;

            return (
              <Note
                key={idx}
                note={note}
                user={user}
                showDelete={isUserActiveUser && !isViewOnly}
                onDelete={() =>
                  setOpenDelete({
                    isOpen: true,
                    note,
                  })
                }
              />
            );
          })}
        </div>
      </div>
      {openDelete.isOpen && (
        <NoteDelete
          open={openDelete.isOpen}
          onClose={() => setOpenDelete({ isOpen: false, note: null })}
          onDelete={handleDeleteNote}
        />
      )}
    </>
  );
}

export default Notes;
